import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './TextAndImagesList.css';
import { faCode } from '@fortawesome/free-solid-svg-icons';
import Modal from './Modals/Modal';
import CodeExampleModal from './Modals/CodeExampleModal';

function CodeExampleList({ curriculum, setCurriculum, clCardItem, setClCardItem, lessonParent, isUploadingViaApi, setIsUploadingViaApi }) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div>
      <div className="CITLST NotYetAvailable" onClick={() => setIsOpen(true)}>
        <div className="CITLST_A1">
          <FontAwesomeIcon icon={faCode} />
        </div>
        <div className="CITLST_A2">
          Code Example
        </div>
      </div>
      <Modal isOpen={isOpen} setIsOpen={setIsOpen}>
        <CodeExampleModal curriculum={curriculum} setCurriculum={setCurriculum} clCardItem={clCardItem} setClCardItem={setClCardItem} lessonParent={lessonParent} isUploadingViaApi={isUploadingViaApi} setIsUploadingViaApi={setIsUploadingViaApi} />
      </Modal>
    </div>
  );
}

export default CodeExampleList;
